module.exports = __webpack_public_path__ + "img/Winterbereit.cc881535.svg";